import src from "IMAGE";
export default { src, width: 200, height: 51, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAY0e90GL1eCBhYxRQYWM0kGDx8mBi9GRgZBWlMGNEc+AAxZlMMMM0dGDBs2RQwjS2UMJE9rDDxdYAxScGMMXX9y1IkPHGqDfLUAAAAASUVORK5CYII="};
